import React, { useEffect } from 'react';
import { DashboardMemoryView } from '../../components/DashboardMemoryView';
import { NoSubCard } from '../../components/NoSubCard';
import { useUser } from '../../shared/use-user';
import { useDocumentTitle } from '../../shared/use-document-title';
// import { useRouting } from '../../shared/use-routing';
// import { loadScript } from '../../shared/load-script';
// import { getZendeskMessagingToken } from '../../../lib/use-cases/get-zendesk-messaging-token';

// const ZENDESK_WIDGET_ID = 'ze-snippet';
// const ZENDESK_WIDGET_SRC = 'https://static.zdassets.com/ekr/snippet.js?key=d91e1367-9eeb-43cd-8742-1563ba7278ee';

function DashboardPage() {
    useDocumentTitle('Dashboard');

    const { userData } = useUser();
    // const { lang } = useRouting();

    // useEffect(() => {
    //     if (lang !== 'en') {
    //         return;
    //     }

    //     loadScript(ZENDESK_WIDGET_SRC, {
    //         id: ZENDESK_WIDGET_ID,
    //         callback: () => {
    //             window.zE?.('messenger', 'loginUser', callback => {
    //                 getZendeskMessagingToken()
    //                     .then(({ token }) => callback(token))
    //                     .catch(() => {});
    //             });
    //         }
    //     });
    // }, [lang]);

    if (!userData.isActiveSubscription) {
        return <NoSubCard />;
    }

    return <DashboardMemoryView />;
}

export {
    DashboardPage
};
